import { FeeOverride } from '@new/domains/bookings/ModifyBookingSidePanel/components/ModifyBookingForm/ModifyBookingForm.types'
import { PreviewBookingAlterationFeeItemActual } from '@new/domains/bookings/ModifyBookingSidePanel/ModifyBookingSidePanel.types'
import { checkIsCreditCardFee } from '@new/domains/bookingsTapeChart/components/CreateBookingForm/components/EditBookingPrice/EditBookingPrice.utils'

export const getFeeOverrideWithCCFee = (
  currentFees?: FeeOverride[],
  creditCardItem?: PreviewBookingAlterationFeeItemActual,
  includeCCfee?: boolean,
) => {
  const feeOverrideWithoutCCFee = currentFees?.filter(fee => !checkIsCreditCardFee(fee.feeId)) || []
  const existingCCFeeOverride = currentFees?.find(fee => checkIsCreditCardFee(fee.feeId))
  const shouldZeroCCfee = !!creditCardItem && includeCCfee === false

  if (shouldZeroCCfee) {
    // User unchecked the CC fee — zero it out
    return [
      ...feeOverrideWithoutCCFee,
      {
        feeId: creditCardItem.id,
        name: creditCardItem.name,
        itemId: creditCardItem.itemId,
        value: 0,
      },
    ] as FeeOverride[]
  }

  if (existingCCFeeOverride) {
    // User has manually edited the CC fee value — preserve the override
    return [...feeOverrideWithoutCCFee, existingCCFeeOverride]
  }

  // No CC fee override — let the backend calculate it
  return feeOverrideWithoutCCFee
}
